import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, User, Clock } from 'lucide-react';
import { blogPosts } from '../mockData';

const BlogGrid = ({ limit = null }) => {
  const displayPosts = limit ? blogPosts.slice(0, limit) : blogPosts;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <motion.div 
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      {displayPosts.map((post) => (
        <motion.article
          key={post.id}
          variants={itemVariants}
          whileHover={{ y: -4 }}
          className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all cursor-pointer border border-grey"
        >
          <div className="relative h-48 overflow-hidden">
            <img 
              src={post.image} 
              alt={post.title}
              className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
            />
            <div className="absolute top-4 left-4">
              <span className="service-button bg-light-pink text-black border-light-pink">
                {post.category}
              </span>
            </div>
          </div>
          
          <div className="p-6">
            <h3 className="text-xl font-semibold mb-3 hover:text-light-pink transition-colors">
              <Link to={`/blog/${post.id}`}>{post.title}</Link>
            </h3>
            <p className="text-dark-grey mb-4 line-clamp-2">{post.excerpt}</p>
            
            <div className="flex items-center justify-between text-sm text-mid-grey">
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-1">
                  <User size={14} />
                  <span>{post.author}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Clock size={14} />
                  <span>{post.readTime}</span>
                </div>
              </div>
            </div>
            
            <div className="flex items-center gap-1 text-sm text-mid-grey mt-2">
              <Calendar size={14} />
              <span>{new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
            </div>
          </div>
        </motion.article>
      ))}
    </motion.div>
  );
};

export default BlogGrid;
